import { render, staticRenderFns } from "./index.vue?vue&type=template&id=b03267d2&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./issued-invoices-details.scss?vue&type=style&index=0&id=b03267d2&prod&scoped=true&lang=sass&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b03267d2",
  null
  
)

export default component.exports